import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const RunningJobsList = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default RunningJobsList;